<template>
    <div class="MobileProductList">
        <v-tabs
            v-model="tab"
            align-tabs="center"
            center-active
            color="primary"
            show-arrows
        >
            <v-tab
                v-for="(section, index) in productsPerSection"
                :key="index"
                :value="index"
                class="MobileProductList-tabItem"
            >
                {{ section.name }}
            </v-tab>
        </v-tabs>

        <v-carousel
            v-model="tab"
            :show-arrows="false"
            class="MobileProductList-carousel"
            height="auto"
            hide-delimiters
        >
            <v-carousel-item
                v-for="(section, index) in productsPerSection"
                :key="index"
                :value="index"
                class="MobileProductList-tabContent"
            >
                <mobile-sub-product-list
                    v-bind="section"
                    :key="section.id"
                    class="MobileProductList-subProductList"
                />
            </v-carousel-item>
        </v-carousel>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import MobileSubProductList from '@/StoreWeb/components/product/MobileSubProductList.vue'

defineProps({
    productsPerSection: {
        type: Array,
        required: true
    }
})

const tab = ref(0)
</script>

<style scoped lang="scss">
@import 'globalScss';

.MobileProductList {
    height: 100%;
    padding-bottom: $s10;

    &-carousel {
        height: 100% !important;
    }

    &-tabContent {
        padding-top: $s2;
    }

    &-subProductList {
        padding: 0 $s6;
    }

    &-tabItem {
        padding-right: $s2;
        padding-left: $s2;

        &.v-btn.v-tab {
            min-width: 0;
        }
    }

    :deep(.v-slide-group__prev),
    :deep(.v-slide-group__next) {
        flex: 0 1 36px;
        min-width: 36px;
        font-size: 22px;
    }
}
</style>
